<template>
  <v-card outlined class="mt-2 mb-2">
    <v-card-text>
      <v-card-title>Módulos Complementares</v-card-title>
      <v-row>
        <v-col cols="12" xs="12">
          <v-card outlined>
            <v-card-title>Recursos Adicionais</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="12" sm="12">
                  <soi-switch :name="'Habilitar triagem'"
                    :label="localValue.triagemAtiva ? 'Triagem Habilitada' : 'Habilitar triagem'"
                    v-model="localValue.triagemAtiva" :disabled="disabled" />
                </v-col>
                <v-col cols="12" md="12" sm="12">
                  <soi-switch :name="'Habilitar Memed'"
                    :label="localValue.memedAtiva ? 'Memed Habilitada' : 'Habilitar Memed'"
                    v-model="localValue.memedAtiva" :disabled="disabled" />
                </v-col>
                <v-col cols="12" md="12" sm="12">
                  <soi-switch :name="'Habilitar risco de falta (no-show)'"
                    :label="localValue.noShowPredictionAtiva ? 'Risco de falta (no-show) Habilitado' : 'Habilitar risco de falta (no-show)'"
                    v-model="localValue.noShowPredictionAtiva" :disabled="disabled" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import ModulosComplementares from '@/models/objetosDeValor/ModulosComplementares';
import { MensagemMixin } from '@/helpers/MensagemHelper';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'SoiModulosComplementares',
  props: {
    value: {
      type: Object as PropType<ModulosComplementares | null>,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      localValue: new ModulosComplementares(),
      isInitializing: true,
    };
  },
  watch: {
    value: {
      handler(newValue: ModulosComplementares | null) {
        if (newValue) {
          this.localValue.triagemAtiva = newValue.triagemAtiva ?? false;
          this.localValue.memedAtiva = newValue.memedAtiva ?? false;
          this.localValue.noShowPredictionAtiva = newValue.noShowPredictionAtiva ?? false;
        } else {
          this.localValue = new ModulosComplementares();
        }

        this.$nextTick(() => {
          this.isInitializing = false;
        });
      },
      immediate: true,
      deep: true,
    },
    'localValue.triagemAtiva': {
      handler(newVal: boolean, oldVal: boolean) {
        if (!this.isInitializing && newVal !== oldVal) {
          this.emitUpdate();
          const mensagem = newVal
            ? 'Triagem habilitada com sucesso.'
            : 'Triagem desabilitada.';
          MensagemMixin(2000, 'success', mensagem);
        }
      },
    },
    'localValue.memedAtiva': {
      handler(newVal: boolean, oldVal: boolean) {
        if (!this.isInitializing && newVal !== oldVal) {
          this.emitUpdate();
          const mensagem = newVal
            ? 'Memed habilitada com sucesso.'
            : 'Memed desabilitada.';
          MensagemMixin(2000, 'success', mensagem);
        }
      },
    },
    'localValue.noShowPredictionAtiva': {
      handler(newVal: boolean, oldVal: boolean) {
        if (!this.isInitializing && newVal !== oldVal) {
          this.emitUpdate();
          const mensagem = newVal
            ? 'Risco de falta (no-show) habilitado com sucesso.'
            : 'Risco de falta (no-show) desabilitado.';
          MensagemMixin(2000, 'success', mensagem);
        }
      },
    },
  },
  methods: {
    emitUpdate(): void {
      this.$emit('input', { ...this.localValue });
    },
  },
});
</script>
